import { Component } from '@angular/core';

@Component({
  selector: 'app-regulations-and-rules',
  templateUrl: './regulations-and-rules.component.html',
  styleUrl: './regulations-and-rules.component.scss'
})
export class RegulationsAndRulesComponent {

}
